<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('orders.refundedOrdersTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :defaultHideCol="defaultHideCol"
          :storageKey="'cols_refundedOrder_v2'"
          :resultsVersion="resultsVersion"
          :filterMade="filterMade"
          :totalResult="totalResult"
          :warehouseFilterItems="warehouses"
          :warehouseFilterChange="handleWarehouseFilter"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :loggedInUserData="loggedInUserData"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <td>{{ r.theOrderID }}</td>
                <td>{{ r.last_order_invoice }}</td>
                <td>{{ r.user_id }}</td>
                <td>{{ r.phone_number }}</td>
                <td class="ws-nowrap">
                  <img v-if="r.profile_image" :src="r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span class="customer-name-stack">
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>{{ r.full_name }}</span>
                    <span v-if="r.phone_number" class="customer-phone-line">{{ r.phone_number }}</span>
                    <span v-if="r.phone_number_2" class="customer-phone-line">{{ r.phone_number_2 }}</span>
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td>{{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }}</td>
                <td>{{ r.brand || '—' }}</td>
                <td style="text-align:center;">
                  <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                    <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                  </a>
                  <span v-else style="color:#bbb;">—</span>
                </td>
                <td style="text-align:center">
                  <img
                    v-if="r.image"
                    :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                    width="130"
                    style="border-radius:4px; cursor:pointer;"
                    @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                  />
                  <span v-else style="color:#bbb; font-size:11px;">—</span>
                </td>
                <td>
                  <span
                    style="display:inline-block; padding:2px 8px; border-radius:12px; font-size:12px; font-weight:500;"
                    :style="{ backgroundColor: '#FF6B81', color: '#FFFFFF' }"
                  >{{ $_status_label(r.status) }}</span>
                </td>
                <td>{{ r.country || '—' }}</td>
                <!-- Summary (Price/Shipping/Total/Size) -->
                <td class="combined-cell-td">
                  <div class="combined-cell">
                    <div><span class="combined-cell-label">{{ $t('columns.price') }}:</span> {{ r.item_price ? '$' + r.item_price : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.shipping') }}:</span> {{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.total') }}:</span> {{ r.total_amount ? '$' + r.total_amount : '—' }}</div>
                    <div class="combined-cell-divider"></div>
                    <div><span class="combined-cell-label">{{ $t('columns.qty') }}:</span> {{ r.quantity || '—' }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.size') }}:</span> {{ r.size || '—' }}</div>
                  </div>
                </td>
                <td>{{ r.note }}</td>
                <td>{{ r.refund_number }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.refund_note }}</td>
                <td>{{ r.item_price ? '$' + r.item_price : '—' }}</td>
                <td>{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</td>
                <td>{{ r.total_amount ? '$' + r.total_amount : '—' }}</td>
                <td>{{ r.size || '—' }}</td>
                <td>{{ r.quantity || '—' }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  class="rtl-pl-10 rtl-pr-5"
                >
                  <a
                    style="color:#01579B"
                    :tooltip="$t('orders.viewDetails')"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('add_refund_number')"
                  class="icon-gap-5"
                >
                  <a
                    style="color:#039a7c"
                    :tooltip="$t('orders.addRefundNumberTooltip')"
                    @click="openAddRefundNumberModal(r.order_id, r.refund_number)"
                  >
                    <i class="material-icons">add_circle</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <div v-if="isMobile">
            <div
              v-for="(r, index) in apiResults"
              :key="r.order_id"
              class="moc-container"
            >
              <div class="moc-card">
                <div class="moc-header">
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id]"
                    v-model="qrCodeValues"
                  />
                  <span class="moc-item-code">{{ r.theOrderID }}</span>
                  <span class="moc-status-badge" :style="{ background: '#FF6B81', color: '#FFFFFF' }">
                    {{ $_status_label(r.status) }}
                  </span>
                </div>
                <div class="moc-body">
                  <div class="moc-row--2col">
                    <div><span class="moc-label">{{ $t('columns.invoiceNo') }}:</span><span class="moc-value">{{ r.last_order_invoice || '—' }}</span></div>
                    <div><span class="moc-label">{{ $t('columns.customerId') }}:</span><span class="moc-value">{{ r.user_id || '—' }}</span></div>
                  </div>
                  <div class="moc-row">
                    <span class="moc-label">{{ $t('columns.customer') }}:</span>
                    <span class="moc-value">{{ r.full_name }}</span>
                  </div>
                  <div class="moc-row">
                    <span class="moc-label">{{ $t('columns.item') }}:</span>
                    <span class="moc-value">{{ r.product_name }}</span>
                  </div>
                  <div class="moc-row">
                    <span class="moc-label">{{ $t('columns.warehouse') }}:</span>
                    <span class="moc-value">{{ r.country || '—' }}</span>
                  </div>
                  <div class="moc-row--3col">
                    <div><span class="moc-label">{{ $t('columns.price') }}</span><span class="moc-value">{{ r.item_price ? '$' + r.item_price : '—' }}</span></div>
                    <div><span class="moc-label">{{ $t('columns.shipping') }}</span><span class="moc-value">{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</span></div>
                    <div><span class="moc-label">{{ $t('columns.total') }}</span><span class="moc-value">{{ r.total_amount ? '$' + r.total_amount : '—' }}</span></div>
                  </div>
                  <div class="moc-row" v-if="r.note">
                    <span class="moc-label">{{ $t('shipOnly.orderNoteColumn') }}:</span>
                    <span class="moc-value">{{ r.note }}</span>
                  </div>
                  <div class="moc-row" v-if="r.refund_number">
                    <span class="moc-label">{{ $t('columns.refundNumber') }}:</span>
                    <span class="moc-value">{{ r.refund_number }}</span>
                  </div>
                  <div class="moc-row" v-if="r.refund_note">
                    <span class="moc-label">{{ $t('columns.refundNote') }}:</span>
                    <span class="moc-value">{{ r.refund_note }}</span>
                  </div>
                </div>
                <div class="moc-actions">
                  <a v-if="$_has_perm('view_order_detail')" style="color:#01579B" :tooltip="$t('orders.viewDetails')" @click="initDetail('modal_showApp', r.order_id)">
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <a v-if="$_has_perm('add_refund_number')" style="color:#039a7c" :tooltip="$t('orders.addRefundNumberTooltip')" @click="openAddRefundNumberModal(r.order_id, r.refund_number)">
                    <i class="material-icons">add_circle</i>
                  </a>
                </div>
              </div>
            </div>
            <v-alert type="error" :value="alertValue"> {{ $t('common.noResultsFound') }} </v-alert>
          </div>

          <v-dialog v-model="lightboxOpen" max-width="600px">
            <v-card>
              <v-card-actions><v-spacer></v-spacer><v-btn icon @click="lightboxOpen=false"><v-icon>close</v-icon></v-btn></v-card-actions>
              <v-card-text style="text-align:center; padding-top:0">
                <img :src="lightboxImage" style="max-width:100%;max-height:80vh;" />
              </v-card-text>
            </v-card>
          </v-dialog>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <add-refund-number
            :addRefundNumberData="addRefundNumberData"
            :closeAddRefundNumberModal="closeAddRefundNumberModal"
            :addRefundNumberModal="addRefundNumberModal"
            :successAlert="successAlert"
            :addRefundNumber="addRefundNumber"
          ></add-refund-number>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import addRefundNumber from './addRefundNumber'
import axios from 'axios'
import swal from 'sweetalert'
import statusHelpers from '../mixins/statusHelpers'

export default {
  mixins: [statusHelpers],
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'add-refund-number': addRefundNumber
  },
  mounted() {
    this.$_fetch_statuses()
    this.getWarehouses()
    this.getLoggedInUser()
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      { label: this.$t('common.user'), text: this.$t('common.user'), value: '2', sortable: false, searchable: false, name: 'user' },
      { label: this.$t('columns.itemCode'), text: this.$t('columns.itemCode'), value: '3', sortable: true, searchable: true, name: 'theOrderID' },
      { label: this.$t('columns.invoiceNo'), text: this.$t('columns.invoiceNo'), value: '4', sortable: true, searchable: false, name: 'last_order_invoice' },
      { label: this.$t('columns.customerId'), text: this.$t('columns.customerId'), value: '5', sortable: true, searchable: true, name: 'user_id' },
      { label: this.$t('columns.phoneNumber'), text: this.$t('columns.phoneNumber'), value: '6', sortable: true, searchable: true, name: 'phone_number' },
      { label: this.$t('columns.customerName'), text: this.$t('columns.customerName'), value: '7', sortable: true, searchable: true, name: 'full_name' },
      { label: this.$t('columns.itemName'), text: this.$t('columns.itemName'), value: '8', sortable: true, searchable: true, name: 'product_name' },
      { label: this.$t('columns.brand'), text: this.$t('columns.brand'), value: '9', sortable: true, searchable: true, name: 'brand' },
      { label: this.$t('columns.url'), text: this.$t('columns.url'), value: '10', sortable: false, searchable: false, name: 'product_url' },
      { label: this.$t('columns.image'), text: this.$t('columns.image'), value: '11', sortable: false, searchable: false, name: 'image' },
      { label: this.$t('columns.status'), text: this.$t('columns.status'), value: '12', sortable: true, searchable: true, name: 'status' },
      { label: this.$t('columns.warehouse'), text: this.$t('columns.warehouse'), value: '13', sortable: true, searchable: true, name: 'country' },
      { label: this.$t('columns.summary'), text: this.$t('columns.summary'), value: '14', sortable: false, searchable: false, name: 'price_all' },
      // { label: 'Int. Tax', text: 'Int. Tax', value: '18', sortable: true, searchable: true, name: 'national_tax' },
      // { label: 'Tax', text: 'Tax', value: '19', sortable: true, searchable: true, name: 'tax' },
      // { label: 'Shipzone Fee', text: 'Shipzone Fee', value: '20', sortable: true, searchable: true, name: 'kreenex_fee' },
      // { label: 'Discount', text: 'Discount', value: '21', sortable: true, searchable: true, name: 'discount' },
      // { label: 'Bank Name', text: 'Bank Name', value: '22', sortable: true, searchable: true, name: 'bank_name' },
      // { label: this.$t('columns.type'), text: this.$t('columns.type'), value: '23', sortable: true, searchable: true, name: 'transportation_type_obj' },
      { label: this.$t('columns.note'), text: this.$t('columns.note'), value: '15', sortable: true, searchable: true, name: 'note' },
      { label: this.$t('columns.refundNumber'), text: this.$t('columns.refundNumber'), value: '16', sortable: true, searchable: true, name: 'refund_number' },
      { label: this.$t('common.date'), text: this.$t('common.date'), value: '17', sortable: true, searchable: true, name: 'refund_date' },
      { label: this.$t('columns.refundNote'), text: this.$t('columns.refundNote'), value: '18', sortable: true, searchable: true, name: 'refund_note' },
      { label: this.$t('columns.price'), text: this.$t('columns.price'), value: '19', sortable: true, searchable: true, name: 'item_price' },
      { label: this.$t('columns.shipping'), text: this.$t('columns.shipping'), value: '20', sortable: true, searchable: true, name: 'internal_shipping_handling' },
      { label: this.$t('columns.total'), text: this.$t('columns.total'), value: '21', sortable: true, searchable: true, name: 'total_amount' },
      { label: this.$t('columns.size'), text: this.$t('columns.size'), value: '22', sortable: true, searchable: true, name: 'size' },
      { label: this.$t('columns.qty'), text: this.$t('columns.qty'), value: '23', sortable: true, searchable: true, name: 'quantity' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      qrCodeValues: [],
      loggedInUserData: {},
      isMobile: false,
      defaultHideCol: ['6', '15', '19', '20', '21', '22', '23'],
      url: 'api/refunded_order',
      orderDetailUrl: 'api/show_order_detail',
      addRefundNumberUrl: 'api/add_refund_number',
      alertValue: false,
      checkAlert: false,
      successAlert: false,
      addRefundNumberModal: false,
      orderID: '',
      filterMade: false,
      totalResult: 0,
      resultsVersion: 0,
      queryParameter: true,
      detialData: {
        the_tl_price: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        coupon_percentage: '',
        type: '',
        theOrderID: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        bank_name: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        discount: '',
        item_type: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        note: ''
      },
      prevSearchQuery: '',
      warehouses: [],
      lightboxImage: null,
      lightboxOpen: false,
      addRefundNumberData: {
        refund_number: ''
      },
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'orders.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        warehouse_id_fk: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    sendToExport() {
      let searchValue = this.tableData.search !== '' ? this.tableData.search : '0'
      let column = this.tableData.column !== '' ? this.tableData.column : '0'
      let sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0'
      let searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0'
      let searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0'
      let fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0'
      let toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0'
      let loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      let warehouses = loggedInUserData.warehouse_id_fk
      let perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page

      if (
        searchValue !== '0' ||
        searchedOneCol !== '0' ||
        searchedOneVal !== '0' ||
        toDate !== '0' ||
        fromDate !== '0'
      ) {
        perPage = '0'
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      window.location.replace(
        fullHostName +
        '/api/refunded_order/export?searchValue=' +
        searchValue +
        '&column=' +
        column +
        '&sortDir=' +
        sortDir +
        '&searchedOneCol=' +
        searchedOneCol +
        '&searchedOneVal=' +
        searchedOneVal +
        '&from_date=' +
        fromDate +
        '&to_date=' +
        toDate +
        '&warehouses=' +
        warehouses +
        '&per_page=' +
        perPage +
        '&remove_pagination=true'
      )
    },

    checkAll() {
      this.qrCodeValues = this.apiResults.map(r => [r.order_id])
    },

    unCheckAll() {
      this.qrCodeValues = []
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    openAddRefundNumberModal(orderID, refundNumber) {
      this.orderID = orderID
      this.addRefundNumberData.refund_number = refundNumber
      this.addRefundNumberModal = true
    },

    closeAddRefundNumberModal() {
      this.addRefundNumberModal = false
      this.successAlert = false
    },

    addRefundNumber() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.addRefundNumberUrl + '/' + this.orderID, this.addRefundNumberData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.successAlert = true
          this.getResults()
          let self = this
          setTimeout(() => {
            self.closeAddRefundNumberModal()
          }, 1500)
        })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action, affecting rows the user never intended
      // to touch in the current (filtered) view.
      this.qrCodeValues = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }
          this.resultsVersion++

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          if (theDatatable) {
            theDatatable.classList.remove('slide-table-out')
          }
          setTimeout(function () {
            if (thePanel) thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'orders.updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'orders.updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse_id_fk = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    resetGetResults2() {
      this.resetGetResults()
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      this.warehouses = []
      axios.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((w) => {
            this.warehouses.push({ text: w.name, value: w.warehouse_id })
          })
        })
    },

    handleWarehouseFilter(val) {
      this.tableData.warehouse_id_fk = Array.isArray(val) && val.length ? val.join(',') : ''
      this.url = 'api/refunded_order'
      this.getResults()
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
.customer-name-stack {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
}
.customer-phone-line {
  display: block;
  font-size: 14px;
  color: #666;
}
.combined-cell-td {
  vertical-align: middle;
}
.combined-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  font-size: 15px;
  line-height: 1.4;
  white-space: nowrap;
}
.combined-cell-label {
  color: #888;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/* Mobile order cards: see assets/mobile-order-cards.css */
</style>



// WEBPACK FOOTER //
// src/components/refundedOrder.vue